











import { defineComponent, onBeforeMount } from '@vue/composition-api'
import Layout from '@/components/organisms/common/Layout.vue'
import SpecialOfferForm from '@/components/organisms/special-offers/SpecialOfferForm.vue'
import { useActions, useGetters } from 'vuex-composition-helpers'
import { UserGetters } from '@/store/user/getters'
import { UpdateSpecialOfferDto } from '../../../api/@types'
import { SpecialOfferActions } from '@/store/special-offer/actions'
import { SpecialOfferGetters } from '@/store/special-offer/getters'

export default defineComponent({
  name: 'SpecialOfferEdit',
  components: { Layout, SpecialOfferForm },
  setup(props, context) {
    const store = context.root.$store
    onBeforeMount(() => {
      store.dispatch(
        'specialOffer/getSpecialOffer',
        context.root.$route.params.id,
      )
    })

    const { user } = useGetters<UserGetters>('user', ['user'])
    const { updateSpecialOffer } = useActions<SpecialOfferActions>(
      'specialOffer',
      ['updateSpecialOffer'],
    )

    const { specialOffer } = useGetters<SpecialOfferGetters>('specialOffer', [
      'specialOffer',
    ])

    const save = async (body: UpdateSpecialOfferDto) => {
      const id = context.root.$route.params.id
      await updateSpecialOffer({ id, body })
      context.root.$router.push('/special-offers')
    }

    const cancel = () => {
      context.root.$router.push('/special-offers')
    }
    return { user, specialOffer, save, cancel }
  },
})
